import { render } from "./IndexInformationVideoGuide.vue?vue&type=template&id=6c28432a"
import script from "./IndexInformationVideoGuide.vue?vue&type=script&lang=js"
export * from "./IndexInformationVideoGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__